import { IUserUpdateRequest } from '@kcftech/prometheustypescriptapiclient';
import { TextInlineEditor } from 'components/inline_edit/TextInlineEditor';
import { usePermissions } from 'contexts/PermissionsContext';
import { UsersTableCellProps } from 'pages/Settings/Users/UsersTable';
import { updateUser } from 'utils/user';

export type UserNameInlineEditorProps = UsersTableCellProps &
    Readonly<{
        value: string;
    }>;

export function UserNameInlineEditor({
    rowData,
    onChange,
    value,
}: UserNameInlineEditorProps) {
    const { canEditUserProperties } = usePermissions();

    const onUpdateUserProperties = async (
        updatedProperty: Partial<IUserUpdateRequest>
    ) => {
        await updateUser(rowData.Id, {
            ...updatedProperty,
        });
        onChange();
    };

    return (
        <div title={value}>
            <TextInlineEditor
                value={value}
                valueClass="ellipsis-1-line"
                onConfirm={(val) =>
                    value === rowData.FirstName
                        ? onUpdateUserProperties({ FirstName: val })
                        : onUpdateUserProperties({ LastName: val })
                }
                validate={(val) => {
                    if (val && val.length > 50) {
                        return 'Maximum 50 characters';
                    }
                    return undefined;
                }}
                isDisabled={!canEditUserProperties}
            />
        </div>
    );
}
